window.addEventListener('load', () => {
  const eventPresent = document.getElementById('event_present')
  const presents = document.getElementsByClassName('component-gift-banner-container')

  // プレゼントバナーがない場合は何もしない
  if (!eventPresent) return

  // PCのスタイルを適用する横幅の場合は何もしない
  if (window.innerWidth >= 989) return

  // 全てのプレゼントバナーを対象
  for(let i = 0; i < presents.length; i++){
    const title = presents[i].getElementsByClassName('component-gift-banner__title')[0]
    // タイトルが2行の場合、期間限定アイコンの表示位置を変更
    if(title.clientHeight > 33){
      const limitedTimeOffer = presents[i].getElementsByClassName('component-gift-banner__limited_time_offer')[0]
      limitedTimeOffer.style.top = "-2px"
    }
  }
})
